import React from 'react';
import { HeaderSplashImage, PageHeader } from 'acscp/components/common/pageHeader';
import { withPageLayout } from 'acscp/components/layout/pageLayout';
import { FormattedMessage } from 'react-intl';
import { LoyaltyTermsAndConditionsPageContent } from '../loyalty/loyaltyTermsAndConditionsPageContent';

const LoyaltyTermsAndConditionsPage: React.SFC<{}> = () => {
    return (
        <div>
            <PageHeader
                title={
                    <FormattedMessage
                        id={'components.pages.loyaltytermsandconditions.title'}
                        defaultMessage={'My Rewards Terms and Conditions'}
                    />
                }
                splashImage={HeaderSplashImage.People}
            />
            <LoyaltyTermsAndConditionsPageContent />
        </div>
    );
};

const LoyaltyTermsAndConditions = withPageLayout(LoyaltyTermsAndConditionsPage);
export { LoyaltyTermsAndConditions };
